// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { DataTag, InfiniteData } from '@tanstack/react-query';

export function createQueryKey<TValue>() {
  return <TKey extends readonly unknown[]>(key: TKey) =>
    key as DataTag<TKey, TValue>;
}

export function createInfiniteQueryKey<TValue>() {
  return <TKey extends readonly unknown[]>(key: TKey) =>
    key as DataTag<TKey, InfiniteData<TValue>>;
}
